import {removeCartItem, StoreCart, useCart, useCurrency} from "../../../../app/store/store"
import "./Cart.css"
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import SideNavWidget from "../../../../component/sidenavbar/widget/SideNavWidget";
import Button from "../../../../component/button/Button";
import {IconGift, IconX} from "@tabler/icons-react";
import Currency, {formatCurrency} from "../../currency/Currency";
import {useNavigate} from "react-router-dom";
import {totalForMonths} from "../../item/modal/monthPricing";
import {useTranslation} from "react-i18next";

export default function Cart(props: {
    currencies: { [key: string]: Currency }
}) {
    const cart: StoreCart = useAppSelector(useCart);
    const {t} = useTranslation();

    const navigate = useNavigate();

    const dispatch = useAppDispatch();
    const currency = useAppSelector(useCurrency);

    if (cart.items.length <= 0) return null;

    return <SideNavWidget className={"cart"} title={t("cart.title")}>
        <div className={"items"}>
            {
                cart.items.map((item, index) => {
                    if (!item.store) return null;
                    return <div className={"item"} key={index}>
                        <p className={"name"}>
                                <span className={"item-name"}>
                                    {item.store.name}
                                    <span className={"months"}>
                                        {item.months && item.months > 1 ? (
                                            <span className={"months-tag"}>{t("common.months", {count: item.months})}</span>
                                        ) : null}
                                    </span>
                                </span>
                            {item.giftUser ? (
                                <span className={"gift-tag"}>
                                        <IconGift/>
                                        <span className={"user"}>{item.giftUser.name}</span>
                                    </span>
                            ) : null}
                        </p>
                        <p className={"price"}>{formatCurrency(props.currencies[currency], totalForMonths(item.store, item.months ?? 1, currency))}</p>
                        <IconX className={"remove"} onClick={() => {
                            dispatch(removeCartItem(index))
                        }}/>
                    </div>
                })
            }
        </div>
        <div className={"summary"}>
            <p className={"label"}>{t("common.total")}</p>
            <p className={"total"}>{formatCurrency(props.currencies[currency], cart.items.reduce((sum, i) => {
                if (!i.store) return sum;
                return sum + totalForMonths(i.store, i.months ?? 1, currency);
            }, 0))}</p>
        </div>
        <Button onClick={() => navigate("/store/checkout")}>{t("cart.checkout")}</Button>
    </SideNavWidget>
} 